import { type ReactElement } from "react";

import { useTranslation } from "react-i18next";

import { SelectItem } from "@/uiKit/atoms/inputs/SelectItem.tsx";
import { FormSelectInput } from "@/uiKit/molecules/form/FormSelectInput.tsx";

export type PumpBrandFormFieldProps<Brand extends string | undefined> = {
  name?: string;
  brands: readonly Brand[];
  translationMapping: (type: Brand) => string;
  className?: string;
};

export const PumpBrandFormField = <Brand extends string | undefined>({
  name = "pump",
  brands,
  translationMapping,
  className,
}: PumpBrandFormFieldProps<Brand>): ReactElement => {
  const { t } = useTranslation();

  return (
    <FormSelectInput
      id="pump-brand-form-field"
      name={name}
      label={t("diabetesForms.pumpModel")}
      className={className}
      fullWidth
      reserveErrorSpace
    >
      {brands.map(pumpDeviceBrand => (
        <SelectItem key={pumpDeviceBrand} value={pumpDeviceBrand}>
          {t(translationMapping(pumpDeviceBrand))}
        </SelectItem>
      ))}
    </FormSelectInput>
  );
};
